<template>
  <div>
    <div class="container-fluid mt--7">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-3 div_btn_categoria mt-2 pt-2">
            <div class="form-group">
              <router-link to="/cadastrar-grupo">
                <button type="button" class="btn_add">Cadastrar Grupo</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Status</th>
                  <th>Ação</th>
                </thead>
                <tbody class="list">
                  <corpo-tabela-grupo-negocio
                    v-for="categoria in state.categorias"
                    :key="categoria.id"
                    :categoria="categoria"
                    @deletarGrupo="deletarGrupo"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import CorpoTabelaGrupoNegocio from "../../components/CorpoTabelaGrupoNegocio";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaGrupoNegocio,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      categorias: [],
    });
    onMounted(() => {
      fetchGrupo();
    });
    async function fetchGrupo() {
      try {
        const { data } = await services.negocio.getGroupNegocio({
          token,
        });
        state.categorias = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarGrupo(id) {
      if (confirm("Deseja deletar este grupo? ")) {
        try {
          state.isLoading = true;
          const { data } = await services.negocio.deleteGrupo({
            id: id,
            token,
          });
          if (data.status != 200) {
            alert("Erro ao deletar grupo.");
          } else {
            fetchGrupo();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarGrupo,
    };
  },
};
</script>

<style scoped>
table {
  color: black;
}
.div_btn_categoria {
  margin-left: 15px;
}
.div_tabela {
  height: auto;
}
</style>